module.exports = __webpack_public_path__ + "img/spre.c82a8224.svg";